export default __webpack_public_path__ + "static/PersonalisationText_Default-51962e4211a73ae1870343b7bf724123.png";